export const companyTypesDE = [
    {
        label: 'Gewerbebetrieb (nicht eingetragene Einzelfirma)',
        value: 'gewerbebetrieb'
    },
    { label: 'GmbH', value: 'gmbh' },
    { label: 'Freiberufler', value: 'freiberufler' },
    { label: 'e.K.', value: 'ek' },
    { label: 'GbR/BGB-Gesellschaft', value: 'gbr' },
    { label: 'UG', value: 'ug' },
    { label: 'Gmbh & Co. KG', value: 'gmbh_u_co_kg' },
    { label: 'oHG', value: 'ohg' },
    { label: 'KG', value: 'kg' },
    { label: 'Ltd. (mit dt. Niederlassung)', value: 'ltd' },
    { label: 'AG', value: 'aktiengesellschaft' },
    { label: 'Eingetragene Genossenschaft (e.G.)', value: 'eg' },
    { label: 'Gemeinnütziger Verein e.V.', value: 'gemeinnuetziger_verein' },
    { label: 'Partnerschaft', value: 'partnerschaft' },
    {
        label: 'Nicht gemeinnütziger Verein',
        value: 'nicht_gemeinnuetziger_verein'
    },
    { label: 'Eingetragene Einzelfirma', value: 'gewerbebetrieb_eingtr' },
    { label: 'KGaA', value: 'kgaa' },
    { label: 'Andere', value: 'andere' }
];

export const companyTypesUK = [
    {
        label: 'Limited company',
        value: 'limited_liability_company'
    },
    { label: 'Sole trader', value: 'sole_trader' },
    { label: 'Ordinary partnership', value: 'ordinary_partnership' },
    {
        label: 'Limited liability partnership',
        value: 'limited_liability_partnership'
    },
    { label: 'Limited company', value: 'public_limited_company' },
    { label: 'Other', value: 'other' }
];
